import { cartItemTelemedicine } from '@strix/checkout/helpers/cartItemTelemedicine'

const LEVELS = {
  lvl0: 0,
  lvl1: 1,
  lvl2: 2,
  lvl3: 3,
}

export const getCartItemLevel = (item) => {
  const products = {
    AppointmentCartItem: [
      { lvl: LEVELS.lvl1 },
      {
        lvl: LEVELS.lvl2,
        isTelemedicine: true,
      },
      {
        lvl: LEVELS.lvl2,
        isRehasport: true,
      },
      {
        lvl: LEVELS.lvl2,
        isRankingLekarzy: true,
      },
      {
        lvl: LEVELS.lvl2,
        isOSOZ: true,
      },
    ],
    AppointmentWithDoctorCartItem: [
      { lvl: LEVELS.lvl1 },
      {
        lvl: LEVELS.lvl2,
        isTelemedicine: true,
      },
      {
        lvl: LEVELS.lvl2,
        isRehasport: true,
      },
      {
        lvl: LEVELS.lvl2,
        isRankingLekarzy: true,
      },
      {
        lvl: LEVELS.lvl2,
        isOSOZ: true,
      },
    ],
    LensesCartItem: [{ lvl: LEVELS.lvl0 }],
    MedicalCheckCartItem: [{ lvl: LEVELS.lvl2 }],
    MedicalPackageCartItem: [
      { lvl: LEVELS.lvl3 },
      {
        lvl: LEVELS.lvl2,
        isDiagnostyka: true,
      },
    ],
    OneTimeServiceCartItem: [
      { lvl: LEVELS.lvl1 },
      {
        lvl: LEVELS.lvl2,
        isSynevo: true,
      },
      {
        lvl: LEVELS.lvl2,
        isDiagnostyka: true,
      },
    ],
    PackageOfServicesCartItem: [
      { lvl: LEVELS.lvl1 },
      {
        lvl: LEVELS.lvl2,
        isSynevo: true,
      },
      {
        lvl: LEVELS.lvl2,
        isDiagnostyka: true,
      },
    ],
    PackagedServiceCartItem: [{ lvl: LEVELS.lvl1 }],
    PhysicalProductCartItem: [
      { lvl: LEVELS.lvl0 },
      {
        lvl: LEVELS.lvl2,
        isShippingWithBeneficiary: true,
      },
    ],
    PrepaidCardCartItem: [{ lvl: LEVELS.lvl2 }],
    SimpleServiceCartItem: [{ lvl: LEVELS.lvl2 }],
    TrainingCartItem: [{ lvl: LEVELS.lvl0 }],
  }
  const isShippingWithBeneficiary = item.product.shippingWithBeneficiary || false
  const isTelemedicine = cartItemTelemedicine(item)
  const vendorName = item.vendor.name
  const isSynevo = vendorName === 'Synevo'
  const isRehasport = vendorName === 'Rehasport'
  const isRankingLekarzy = vendorName === 'Ranking Lekarzy'
  const isDiagnostyka = vendorName === 'Diagnostyka'
  const isOSOZ = item.vendor.apphubCode === 'OSOZ'

  return products[item._typename]?.reduce((lvl, terms) => {
    if (
      (terms.isShippingWithBeneficiary ? isShippingWithBeneficiary === terms.isShippingWithBeneficiary : true) &&
      (terms.isTelemedicine ? isTelemedicine === terms.isTelemedicine : true) &&
      (terms.isSynevo ? isSynevo === terms.isSynevo : true) &&
      (terms.isOSOZ ? isOSOZ === terms.isOSOZ : true) &&
      (terms.isRehasport ? isRehasport === terms.isRehasport : true) &&
      (terms.isRankingLekarzy ? isRankingLekarzy === terms.isRankingLekarzy : true) &&
      (terms.isDiagnostyka ? isDiagnostyka === terms.isDiagnostyka : true) &&
      terms.lvl > lvl
    ) {
      lvl = terms.lvl
    }
    return lvl
  }, 0) || 0
}
